export enum BonusName {
    BonusFreeSpins = "BonusFreeSpins",
    FreeSpinChoice = "FreeSpinChoice",
    BonusReSpins = "BonusReSpins",
    Scatter = "Scatter"
}